const uploaderLocal = {
  state: {
    messageObj: {
      isShow: true,
      message: "数据加载中..."
    },
    floderObj: {},
    floderObj2: {},
    currentTreeNode: {},
    refreshFolderID: "",
    refreshKey: 0,
    uploadTypeKey: "",
    floderDataLocal: [],
    floderDataLocal2: []
  },

  mutations: {
    XTDESIGN_UPDATE_LOCAL_NODE(state, data) {
      state.currentTreeNode = data;
    },
    XTDESIGN_LOCAL_SUCCEED(state, data) {
      state.refreshFolderID = data;
      state.refreshKey = new Date().getTime();
    },

    XTDESIGN_LOCAL_TYPE(state, data) {
      state.uploadTypeKey = data;
    },
    XTDESIGN_LOCAL_FLODER(state, data) {
      state.floderObj = data || {};
    },
    XTDESIGN_LOCAL_FLODER2(state, data) {
      state.floderObj2 = data || {};
    },
    XTDESIGN_LOCAL_FLODER_DATA(state, data) {
      state.floderDataLocal = data || [];
    },
    XTDESIGN_LOCAL_FLODER_DATA2(state, data) {
      state.floderDataLocal2 = data || [];
    }
  },

  actions: {
    LocalUpdateTreeNode({ commit }, data) {
      commit("XTDESIGN_UPDATE_LOCAL_NODE", data);
    },

    LocalUploadSucceedCB({ commit }, data) {
      commit("XTDESIGN_LOCAL_SUCCEED", data);
    },

    LocalUploadType({ commit }, data) {
      commit("XTDESIGN_LOCAL_TYPE", data);
    },

    LocalUploadSucceedFloder({ commit }, data) {
      commit("XTDESIGN_LOCAL_FLODER", data);
    },

    LocalUploadSucceedFloder2({ commit }, data) {
      commit("XTDESIGN_LOCAL_FLODER2", data);
    },
    LocalUploadFloderData({ commit }, data) {
      commit("XTDESIGN_LOCAL_FLODER_DATA", data);
    },
    LocalUploadFloderData2({ commit }, data) {
      commit("XTDESIGN_LOCAL_FLODER_DATA2", data);
    }
  }
};

export default uploaderLocal;
